import { Button, Tooltip } from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const AiButton = () => {

    return (
        <Tooltip title="AI Settings" arrow placement="top">
            <AutoAwesomeIcon sx={{ color: "#ffffff", p: 0 }} />
        </Tooltip>
    );
};

export default AiButton;
